/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Box, Button, Link, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { LoadState } from "../../../../../../constants/enums";
import { useDispatchWrapper } from "../../../../../../hooks";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";
import {
  downloadCommAutomobileDwellingPDFAsync,
  fetchCommAutomobileDwellingListAsync,
  previewCommAutomobileDwellingPDFAsync,
} from "../../../../../../redux/commAutoPolicy/commAutoCertificates/commAutoCertificatesActions";
import { ICommAutomobileDwelling } from "../../../../../../redux/commAutoPolicy/commAutoCertificates/commAutoCertificates.types";
import { CustomSelect } from "../../../../../../components/formsComponents";
import { renderDropdownValue } from "../../../../../../helpers";
import { NotificationsActive, ThumbUpAlt } from "@mui/icons-material";
import { CustomChip } from "../../../../../../components/CustomChip";
import { LeadOppStatus } from "../../../../../../components/LeadOppStatus/LeadOppStatus";

export const CommAutoDwellingList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { list, loading } = useSelector(
    (storeState: IStoreState) => storeState.commAuto.certificates.dwelling
  );
  const [downloading, setDownloading] = React.useState(false);
  const dispatch = useDispatchWrapper();

  const [selectedConsent, setselectedConsent] = React.useState<{
    isAllSelected: boolean;
    certificate: ICommAutomobileDwelling[];
  }>({
    isAllSelected: false,
    certificate: [],
  });

  const menuItems =
    selectedConsent.certificate.length > 0 || selectedConsent.isAllSelected
      ? [
          {
            key: "action",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={""}
                displayEmpty
                renderValue={renderDropdownValue(`Choose bulk Action`)}
                //onChange={(e) => setBranchOffice(e.target.value as string)}
              >
                <MenuItem value="1">Email</MenuItem>
              </CustomSelect>
            ),
          },
        ]
      : [];

  const DwellingTableProps: IDataTableProps = {
    isPagination: true,
    isDataLoading: loading === LoadState.InProgress,
    selectionMode: "multiple",
    uniqueRowKeyName: "incremental_number",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [...menuItems],
      },
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/dwelling`
                  );
                }}
              >
                + Create
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
    {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        isFirstColumnSticky: true,
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: ICommAutomobileDwelling) => {
          return (
              <StandardTableActions
              downloadLoading={downloading}
              onDownloadPreview={() => {
                dispatch(
                  previewCommAutomobileDwellingPDFAsync(
                    customerPolicyId,
                    row.incremental_number as number,
                    () => {}
                  )
                );
              }}
              onDownLoadClick={() => {
                if (row.incremental_number) {
                  setDownloading(true);
                  dispatch(
                    downloadCommAutomobileDwellingPDFAsync(
                      customerPolicyId,
                      row.incremental_number,
                      () => {
                        setDownloading(false);
                      }
                    )
                  );
                }
              }}
              onEditClick={() => {
                navigate(
                  `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/dwelling/${row.incremental_number}`
                );
              }}
              // onDuplicateClick={() => {
              //   navigate(
              //     `/comm-automobile-policy/${customerId}/policy-forms-tab/${customerPolicyId}/dwelling-declaration-duplicate/${row.incremental_number}`
              //   );
              // }}
            />
          );
        },
      },
      {
        key: "status",
        headerName: "Status",
        fieldName: "status",
        renderType: RenderType.CHIP_SUCCESS,
        onRowCellRender: (value, row: ICommAutomobileDwelling) => {
          return <LeadOppStatus status={row.status} />;
        },
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: RenderType.CHIP_WARNING,
        exportCellWidth: 30,
      },
      {
        key: "applicant_name",
        headerName: "Applicant Name",
        fieldName: "applicant_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "name_of_principal",
        headerName: "Principal Name",
        fieldName: "name_of_principal",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "date_of_birth",
        headerName: "DOB",
        fieldName: "date_of_birth",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "any_additional_applicants",
        headerName: "Additional Applicant",
        fieldName: "any_additional_applicants",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "source_of_applicants_income",
        headerName: "Applicant Source Income",
        fieldName: "source_of_applicants_income",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "policy_term_info_proposed_effective_date",
        headerName: "Effective Date",
        fieldName: "policy_term_info_proposed_effective_date",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "brokerage",
        headerName: "Brokerage",
        fieldName: "brokerage",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "broker_id",
        headerName: "Broker ID",
        fieldName: "broker_id",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "broker_email",
        headerName: "Broker Email",
        fieldName: "broker_email",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "tel",
        headerName: "Tel",
        fieldName: "tel",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      {
        key: "fax",
        headerName: "Fax",
        fieldName: "fax",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
      },
      
    ],
    items: list,
    onSelection: (isAllSelected: boolean, rows: ICommAutomobileDwelling[]) => {
        setselectedConsent({ isAllSelected: isAllSelected, certificate: rows });
    },
  };

  React.useEffect(() => {
    dispatch(fetchCommAutomobileDwellingListAsync(customerPolicyId));
  }, [customerPolicyId]);

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...DwellingTableProps} />
      </Box>
    </>
  );
};
